// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__P3T1C","right":"styles_right__2ti-x"};